<template>
  <div class="rank_select">
    <div class="label" @click="show=true">
      {{ selectedItem.name }} <van-icon name="arrow-down" />
    </div>
    <div v-show="show" class="van-overlay my_overlay" style="z-index: 11;" @click="show=false"></div>
    <div v-show="show" class="dropdown">
      <div class="sanjiao sanjiao_down"></div>
      <div class="content">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="item"
          @click="onSelected(item)"
        >
          {{ item.name }}
          <van-icon v-if="item.code==selectedItem.code" class="icon" name="success" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from 'vant'

export default {
  name: 'CompeleSelect',
  model: {
    prop: 'value',
    event: 'confirm'
  },
  props: {
    value: {
      type: String
    },
    clazzType: {
      type: Number
    }
  },
  components: {
    [Icon.name]: Icon
  },
  data () {
    return {
      show: false,
      selectedItem: null,
      items: [
        { name: '全部', code: 'all' },
        { name: '已完成', code: 'competed' },
        { name: '未完成', code: 'uncompeted' }
      ]
    }
  },
  created () {
    this.selectedItem = this.items[0]
    this.$emit('confirm', this.selectedItem.code)
  },
  methods: {
    onSelected (item) {
      const temp = Object.assign({}, item)
      this.selectedItem = temp
      this.$emit('confirm', this.selectedItem.code)
      this.show = false
    }
  }
}
</script>

<style scoped lang="scss">
.rank_select {
  color: #8d8d8d;
  font-size: 28px;
  position: relative;
  .label {
    display: flex;
    align-items: center;
  }
  .my_overlay {
    background-color: rgba(0,0,0,0);
  }
  .dropdown {
    color: #5e5e5e;
    background-color: #fff;
    position: absolute;
    top: 60px;
    right: -30px;
    z-index: 12;
    width: 290px;
    box-shadow: 0 0 30px #c9c9c9;
    .item {
      padding: 15px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &:not(:last-child) {
        border-bottom: 1PX solid #ebedf0;
      }
      .icon {
        font-size: 36px;
        color: #f5222d;
      }
    }
  }
  .sanjiao {
    position: absolute;
    top: -25px;
    right: 65px;
    z-index: 13;
  }
  .sanjiao_down{
    width:0;
    height:0;
    overflow:hidden;
    font-size: 0;     /*是因为, 虽然宽高度为0, 但在IE6下会具有默认的 */
    line-height: 0;  /* 字体大小和行高, 导致盒子呈现被撑开的长矩形 */
    border-width:13px;
    border-style:solid;  /*ie6下会出现不透明的兼容问题*/
    border-color: transparent transparent #fff transparent;
  }
}
</style>
